<template>
  <j-modal
    :fullscreen="true"
    :okButtonProps="{ class:{'jee-hidden': disableSubmit} }"
    :title="title"
    :visible="visible"
    :width="width"
    @cancel="handleCancel"
    @ok="handleOk"
    cancelText="关闭"
    switchFullscreen
  >
    <p-tpl-info-form :disabled="disableSubmit" @ok="submitCallback" ref="realForm"></p-tpl-info-form>
  </j-modal>
</template>

<script>

  import PTplInfoForm from './PTplInfoForm'
  export default {
    name: 'PTplInfoModal',
    components: {
      PTplInfoForm
    },
    data () {
      return {
        title: '',
        width: '100%',
        visible: false,
        disableSubmit: false
      }
    },
    methods: {
      add () {
        this.visible = true
        this.$nextTick(() => {
          this.$refs.realForm.add()
        })
      },
      edit (record) {
        this.visible = true
        this.$nextTick(() => {
          this.$refs.realForm.edit(record)
        })
      },
      close () {
        this.$emit('close')
        this.visible = false
      },
      handleOk () {
        this.$refs.realForm.submitForm()
      },
      submitCallback () {
        this.$emit('ok')
        this.visible = false
      },
      handleCancel () {
        this.close()
      }
    }
  }
</script>
